var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
        Object.keys(_vm.currentScreen).length > 0 &&
        Object.keys(_vm.layout).length > 0
    )?_c('div',[_vm._l((_vm.layout.pages),function(page,index){return [_c('div',{key:index,staticClass:"page"},[_vm._l((page),function(section,j){return [_c(section.component,_vm._b({key:j,tag:"v-component",attrs:{"mode":_vm.mode}},'v-component',_vm.getAttributes(section.params),false))]})],2)]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }